import { render, staticRenderFns } from "./RetencionPage.vue?vue&type=template&id=4223dcd0"
import script from "./RetencionPage.js?vue&type=script&lang=js&external"
export * from "./RetencionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports